import React from 'react';

import { LozengeDropdownTrigger } from '@atlaskit/lozenge';

export default (): React.JSX.Element => (
	<LozengeDropdownTrigger appearance="success">Success</LozengeDropdownTrigger>
);
